// ets_tracing: off
export const assignFunction = (ab, c) => {
  const newF = (...x) => ab(...x);

  return Object.assign(newF, c);
};
export const assignCallable = (F, d) => assignFunction(F, Object.assign({}, F, d));
export const wrapFun = g => x => g(x);
export const inhabitTypes = t => t;
//# sourceMappingURL=index.mjs.map